module.exports = __webpack_public_path__ + "img/email.c73260e9.svg";